import { IFAQ } from "@/store/modules/faq/types";
import { baseFAQ } from "./defaultObjects";
import { cloneDeep, defaultsDeep } from "lodash";

export function faqDefault(faq: Partial<IFAQ>): IFAQ {
  return defaultsDeep(cloneDeep(faq), Object.assign({}, baseFAQ()));
}
